import { render } from "./LabRequestDetails.vue?vue&type=template&id=7fc064ac"
import script from "./LabRequestDetails.vue?vue&type=script&lang=js"
export * from "./LabRequestDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__